module.exports = __webpack_public_path__ + "img/1-8134.bcb4f531.png";